import { allApis } from 'src/api/redux/allApis';
import { setPreviewRoute } from './slices/routesSlice';
import type { AppDispatch } from './store';

/**
 * Resets all RTK Query API caches and the previewed route. Call this whenever
 * the user session context changes (logout, start/stop impersonation) so stale
 * data is never served, and the next account never sees the previous account's
 * route preview.
 *
 * The API list is defined once in `src/api/redux/allApis.ts` — add new APIs
 * there and both the store middleware and this reset stay in sync.
 */
export function resetAllApiState(dispatch: AppDispatch) {
  for (const api of allApis) {
    dispatch(api.util.resetApiState());
  }
  dispatch(setPreviewRoute(null));
}
